//IMPORT PACKAGE REFERENCES
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { login, loginWithToken, checkForSSO } from '../state/actions/UserActions';
import { Loading } from '../containers/Loading';
import Cookies from 'universal-cookie';
import { API_ROOT } from '../../config/config';


//UI
import {Button, Input} from 'reactstrap';

const cookies = new Cookies();

//COMPONENT
class LoginPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            password: '',
            username: '',
            passwordRequired: false,
            hasTriedLogin: false,
            isRedirecting: false
        };

        this.emailChange = this.emailChange.bind(this);
        this.passwordChange = this.passwordChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.tokenReceived = this.tokenReceived.bind(this);
        this.pushToSSO = this.pushToSSO.bind(this);

    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if(nextProps.loggedIn) {
            this.props.history.push('/');
        } else if (nextProps.failed) {
            alert(nextProps.message);
        }
    }

    componentDidUpdate(prevProps){
        if(this.props.shouldUseSSO != prevProps.shouldUseSSO){
            this.setState({passwordRequired: !this.props.shouldUseSSO});
            if(this.state.hasTriedLogin) {
                if(this.props.shouldUseSSO) {
                    this.pushToSSO();
                } else {
                    this.setState({hasTriedLogin: false});
                }
            }
        }

        if(this.props.checkingSSOFulfilled != prevProps.checkingSSOFulfilled) {
            this.setState({passwordRequired: !this.props.shouldUseSSO});
            if(this.state.hasTriedLogin && this.props.shouldUseSSO ) {
                this.pushToSSO();
            }
        }

        if(this.props.checkingSSOFailed != prevProps.checkingSSOFailed) {
            this.setState({passwordRequired: !this.props.shouldUseSSO});
            if(this.state.hasTriedLogin && this.props.shouldUseSSO ) {
                this.pushToSSO();
            }
        }
    }

    componentDidMount() {
        localStorage.clear();
        if(this.props.loggedIn) {
            this.props.history.push('/');
        } else {
            this.tokenReceived();
        }

        this.setState({
            isRedirecting: false,
            hasTriedLogin: false
        });
    }

    pushToSSO(){
        if(this.state.username != undefined && this.state.username != '') {
            this.setState({isRedirecting: true});
            window.location = API_ROOT + '/login?email=' + this.state.username;
        }
    }

    passwordChange(event) {
        this.setState({password: event.target.value});
    }

    emailChange(event) {
        this.setState({
            username: event.target.value,
            hasTriedLogin: false
        });
    }

    handleSubmit(){
        this.setState({hasTriedLogin: true});

        if(this.state.passwordRequired) {
            this.setState({hasTriedLogin: false});
            this.props.login(this.state.username, this.state.password);
        } else {
            this.props.checkForSSO(this.state.username);
        }
    }

    handleKeyPress(event) {
        if(event.key === 'Enter') {
            this.handleSubmit(event);
        }
    }

    tokenReceived() {
        let authToken = cookies.get('authToken');
        if(authToken != undefined && authToken != null) {
            this.setState({isRedirecting: true});
            this.props.loginWithToken(authToken);
        }
    }

    render() {
        return (
            <div className="container py-5">
                <div className="login-container">
                    <img className="login-image" src={require('../../images/Shelfy-Logo.png')} />
                    <div className="welcome">Welcome</div>
                    <div className="welcome-message">Sign in to manage Shelfy content</div>
                    <div className="login-form row">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-12 mx-auto">
                                    {!this.props.loggingIn && !this.state.isRedirecting && !this.props.checkingSSOPending && <div>
                                        <div className="form-group">
                                            <Input className="login-input login-textfield" placeholder="Email" onKeyPress={this.handleKeyPress} onChange={this.emailChange} type="email" value={this.state.username} />
                                            {this.state.passwordRequired && 
                                                <Input className="login-input" placeholder="Password" onKeyPress={this.handleKeyPress} onChange={this.passwordChange} type="password" value={this.state.password} />
                                            }
                                            <Button className="login-input login-button button btn-primary" onClick={this.handleSubmit} type="primary">Login</Button>
                                        </div>
                                    </div> }
                                    {(this.props.loggingIn || this.state.isRedirecting || this.props.checkingSSOPending) && 
                                        <Loading/>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

LoginPage.propTypes = {
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    loggedIn: PropTypes.bool.isRequired,
    loggingIn: PropTypes.bool.isRequired,
    failed: PropTypes.bool.isRequired,
    message: PropTypes.string.isRequired,
    login: PropTypes.func.isRequired,
    shouldUseSSO: PropTypes.bool.isRequired,
    loginWithToken: PropTypes.func.isRequired,
    checkForSSO: PropTypes.func.isRequired,
    checkingSSOPending: PropTypes.bool.isRequired,
    checkingSSOFulfilled: PropTypes.bool.isRequired,
    checkingSSOFailed: PropTypes.bool.isRequired,
};

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { loggedIn, loggingIn ,failed, message, shouldUseSSO, checkingSSOPending, checkingSSOFulfilled, checkingSSOFailed} = state.userReducer;
    return { loggedIn, loggingIn, failed, message, shouldUseSSO, checkingSSOPending, checkingSSOFulfilled, checkingSSOFailed };
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({ login, loginWithToken, checkForSSO}, dispatch)
);

const hoc = withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginPage));


// EXPORT COMPONENT

export { hoc as LoginPage };


// WEBPACK FOOTER //
// ./src/components/pages/LoginPage.js